export const AP_HUB_BU_STORAGE_KEY = 'ap_hub_selected_business_unit_id';
export const AP_HUB_DASHBOARD_DATE_RANGE_KEY = 'ap_hub_dashboard_date_range';

export const getDashboardDateRange = () => {
  try {
    const raw = sessionStorage.getItem(AP_HUB_DASHBOARD_DATE_RANGE_KEY);
    if (!raw) return { from: '', to: '' };
    const parsed = JSON.parse(raw);
    return {
      from: parsed?.from || '',
      to: parsed?.to || '',
    };
  } catch {
    return { from: '', to: '' };
  }
};

export const setDashboardDateRange = (range) => {
  sessionStorage.setItem(
    AP_HUB_DASHBOARD_DATE_RANGE_KEY,
    JSON.stringify({ from: range?.from || '', to: range?.to || '' })
  );
};

export const clearDashboardDateRange = () => {
  sessionStorage.removeItem(AP_HUB_DASHBOARD_DATE_RANGE_KEY);
};
